import React, { useState } from "react";
import { validateAnnouncement } from "../../features/demo/demoContract";

const DemoComposer = ({ onSubmit, disabled = false }) => {
  const [form, setForm] = useState({ title: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const change = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: "" }));
  };

  const submit = async (event) => {
    event.preventDefault();
    if (submitting || disabled) return;
    const validation = validateAnnouncement(form);
    setErrors(validation.errors);
    if (!validation.valid) return;

    setSubmitting(true);
    setSubmitError("");
    try {
      await onSubmit(validation.value);
    } catch (error) {
      setSubmitError(error.userMessage || "Preview belum menerima pengumuman. Cuba lagi.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="demo-composer" onSubmit={submit} noValidate>
      <p className="demo-eyebrow">ADMIN DEMO</p>
      <h2>Hantar pengumuman</h2>
      <div className="demo-field">
        <label htmlFor="demo-announcement-title">Tajuk pengumuman</label>
        <input
          id="demo-announcement-title"
          name="title"
          value={form.title}
          maxLength={80}
          onChange={change}
          disabled={disabled}
        />
        {errors.title && <span className="demo-field-error">{errors.title}</span>}
      </div>
      <div className="demo-field">
        <label htmlFor="demo-announcement-message">Mesej pengumuman</label>
        <textarea
          id="demo-announcement-message"
          name="message"
          value={form.message}
          maxLength={280}
          onChange={change}
          disabled={disabled}
        />
        <span className="demo-character-count">{form.message.length}/280</span>
        {errors.message && <span className="demo-field-error">{errors.message}</span>}
      </div>
      {submitError && <p role="alert">{submitError}</p>}
      <button type="submit" disabled={disabled || submitting}>
        {submitting ? "Menghantar…" : "Hantar demo"}
      </button>
    </form>
  );
};

export default DemoComposer;
